import type { ExtractedLeadV2 } from "@/types/lead";

export type SalesDeskLead = {
  id: string;
  name: string;
  initials: string;
  source: string | null;
  need: string;
};

const SOURCE_LABEL: Record<NonNullable<ExtractedLeadV2["lead_source_category"]>, string> = {
  facebook: "Facebook",
  google: "Google",
  shedsforsale_com: "Sheds for Sale",
  drive_by: "Drive-by",
  word_of_mouth: "Word of mouth",
  referral: "Referral",
  bdc_call: "Call",
  other: "Other",
};

function initials(name: string): string {
  const parts = name.trim().split(/\s+/).slice(0, 2);
  const letters = parts.map((part) => part.charAt(0).toUpperCase()).join("");
  return letters || "•";
}

function needLine(extracted: ExtractedLeadV2 | null | undefined): string {
  if (!extracted) return "New conversation";
  const parts = [extracted.size_config, extracted.product_line, extracted.enunciated_budget]
    .map((part) => (typeof part === "string" ? part.trim() : ""))
    .filter(Boolean);
  return parts.join(" · ") || "New conversation";
}

export function salesDeskLeadFromRow(row: { id: string; data: unknown }): SalesDeskLead | null {
  if (!row.data || typeof row.data !== "object") return null;
  const data = row.data as { name?: unknown; extracted?: ExtractedLeadV2 | null; isTest?: unknown };
  if (data.isTest === true) return null;
  const name = typeof data.name === "string" && data.name.trim() ? data.name.trim() : "Unnamed lead";
  const sourceKey = data.extracted?.lead_source_category;
  return {
    id: row.id,
    name,
    initials: initials(name),
    source: sourceKey ? SOURCE_LABEL[sourceKey] : null,
    need: needLine(data.extracted),
  };
}
